import { useState } from "react";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "types/table/TableColumn";
import { RenderRowsAcordosRealizados } from "./RenderRowsAcordosRealizados";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { useGetAcordosRealizados } from "hooks/acordo/useGetAcordosRealizados";
import { RequestAcordo } from "types/request/RequestAcordos";

const TabelaAcordosRealizados = () => {
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("numeroAcordo");
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("DESC");
  const [sortString, setSortString] = useState<string>("numeroAcordo,DESC");
  const [paginaAtual, setPaginaAtual] = useState(1);

  const { unidadeId } = useGestaoCobrancaCadastroContext();

  const params: RequestAcordo = {
    size: 10,
    page: paginaAtual - 1,
    sort: sortString,
    unidadeId: unidadeId,
  };
  const { data: acordos, isFetching } = useGetAcordosRealizados(params);

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "numeroAcordo",
        label: "Número do acordo",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "numeroParcelas",
        label: "Número de parcelas",
        isOrdenavel: false,
        width: "180px",
      },
      {
        id: "valor",
        label: "Valor (R$)",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "valorAcordado",
        label: "Valor acordado (R$)",
        isOrdenavel: true,
        width: "180px",
      },
      {
        id: "situacaoAcordo",
        label: "Situação",
        isOrdenavel: false,
        width: "150px",
      },
      {
        id: "acoes",
        label: "",
        isOrdenavel: false,
        width: "70px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC"
        ? "ASC"
        : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  return (
    <Tabela
      id="tabela-acordos-realizados"
      colunas={createColumns()}
      ordernarPorColuna={ordenarPorColuna}
      ordenacaoAscOuDesc={ordenacaoAscOuDesc}
      ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
      onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
      paginaAtual={paginaAtual}
      quantidadeDePaginas={acordos?.totalPages ?? 0}
      renderCheckBox={false}
      quantidadeDeRegistros={acordos?.totalElements ?? 0}
      isLoading={isFetching}
    >
      <RenderRowsAcordosRealizados registros={acordos?.content ?? []} />
    </Tabela>
  );
};

export default TabelaAcordosRealizados;
